import PropTypes from 'prop-types';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {
    /**
   * The visual style of the Table
   * `dividers` skin puts horizontal dividers between the rows.
   * `comparison` skin put the table in comparison style
   * `simple` standard table
   *
   */ skin: PropTypes.oneOf([
        'simple',
        'comparison',
        'dividers'
    ])
};
const Table = createComponent({
    displayName: 'Table',
    root: 'table',
    propTypes,
    requiredStyleKeys: SWAN_STYLE_KEY_MAP.table,
    propConfig: {
        classNames (props) {
            return [
                `swan-table-skin-${props.skin}`
            ];
        }
    }
});
Table.defaultProps = {
    skin: 'simple'
};

export { Table };
